import { ImageLoaderProps } from 'next/image';
import { CardButton } from '../../../../../../components/Cards/CardButton';
import { getCatchCardEventProperties } from '../../../../../../components/PostsViewer/helpers/getCatchCardEventProperties';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { CatchPostForPostsViewer } from '../../../../../../generated/graphql';
import { EmptyCatchCardImage } from '../../EmptyCatchCardImage/EmptyCatchCardImage';
import { getImgProxyLoader } from '@lib/images/imgProxyLoader';
import { NextImageWrapper } from '../../../../../../components/NextImage/NextImageWrapper';
import { FishCatchesIcon } from '../../../../../../components/Icons/FishCatchesIcon';

export const FishingWaterViewCatchesList = ({
  catchPosts,
  openPostViewer,
}: {
  catchPosts: CatchPostForPostsViewer[];
  openPostViewer: (postId?: string) => Promise<void>;
}) => {
  const { currentPage } = useAnalytics();

  return (
    <div className="bg-lake-fog mt-8 grid grid-cols-2 gap-2 sm:grid-cols-1">
      {catchPosts.map(post => {
        const image = post.images.edges?.[0]?.node ?? null;
        const imageUrl = image?.url;
        const imageWidth = image?.width ?? 0;
        const imageHeight = image?.height;

        const imgProxyLoader = ({ src, width, quality }: ImageLoaderProps): string =>
          getImgProxyLoader(src, width, imageWidth, imageHeight, { quality });

        return (
          <CardButton
            className="relative aspect-2/3 cursor-pointer rounded-md p-0! sm:aspect-video"
            data-testid={`recent-catch-${post._id}`}
            id={post._id}
            key={post._id}
            eventProperties={getCatchCardEventProperties({
              postId: post._id,
              currentPage,
              source: 'explore-fishingwater-drawer',
            })}
            onClick={() => void openPostViewer(post._id)}
            ariaLabel="catch in this fishing water"
          >
            {imageUrl ? (
              <NextImageWrapper
                alt="recently logged catches"
                customPlaceholderIcon={<FishCatchesIcon size={93} />}
                className="size-full rounded-md object-cover"
                src={imageUrl}
                loader={imgProxyLoader}
                fill
                sizes="350px"
              />
            ) : (
              <EmptyCatchCardImage />
            )}
          </CardButton>
        );
      })}
    </div>
  );
};
